import {
  Box,
  Grid,
  makeStyles,
  TextField,
  InputAdornment,
  Button,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Skeleton } from "@material-ui/lab";
import {
  editBook,
  editDelivery,
  editPrice,
} from "../../../redux-store/books/actions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: `1px solid ${theme.palette.secondary.dark}`,
    margin: "20px 0",
  },
  sectionHeading: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
  priceFields: {
    padding: 8,
    margin: "5px 0",
    width: "80%",
  },
  formControlLabel: {
    color: "red",
  },
  subHeading: {
    fontSize: 16,
    fontWeight: 550,
    margin: "10px 0 1px 0",
  },
  subValue: {
    fontSize: 16,
    fontWeight: 500,
    margin: "0px 0 5px 0",
  },
  button: {
    justifyContent: "end",
  },
}));

function Delivery(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { bookId, currentBook } = props;
  const [standard, setStandard] = useState({
    available: true,
    price: 0,
  });
  const [threeDay, setThreeDay] = useState({
    available: true,
    price: 0,
  });
  const [nextDay, setNextDay] = useState({
    available: true,
    price: 0,
  });
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    fetchCurrentBook();
  }, []);

  const handleUpdatePrice = () => {
    let updatedDelivery = {};
    if (standard.available) {
      updatedDelivery = {
        ...updatedDelivery,
        standard_delivery: standard.price,
      };
    }
    if (threeDay.available) {
      updatedDelivery = {
        ...updatedDelivery,
        three_days_delivery: threeDay.price,
      };
    }
    if (nextDay.available) {
      updatedDelivery = {
        ...updatedDelivery,
        next_day_delivery: nextDay.price,
      };
    }
    dispatch(editPrice({ delivery: updatedDelivery }, bookId));

    setEditMode(false);
  };

  const fetchCurrentBook = () => {
    if (currentBook.delivery.next_day_delivery) {
      setNextDay({
        available: true,
        price: currentBook.delivery.next_day_delivery,
      });
    }
    if (currentBook.delivery.three_days_delivery) {
      setThreeDay({
        available: true,
        price: currentBook.delivery.three_days_delivery,
      });
    }
    if (currentBook.delivery.standard_delivery) {
      setStandard({
        available: true,
        price: currentBook.delivery.standard_delivery,
      });
    }
  };

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h2 className={classes.sectionHeading}>Delivery</h2>
        {editMode ? (
          <div className={classes.button}>
            <Button
              disabled={
                nextDay.price <= 0 || threeDay.price <= 0 || standard.price <= 0
              }
              variant="outlined"
              onClick={handleUpdatePrice}
            >
              Update
            </Button>
            <Button
              style={{ marginLeft: "3px" }}
              variant="outlined"
              color="secondary"
              onClick={() => setEditMode(false)}
            >
              Cancel
            </Button>
          </div>
        ) : (
          <Button
            variant="outlined"
            disabled={currentBook.print_on_demand == "admin"}
            onClick={() => setEditMode(true)}
          >
            Edit
          </Button>
        )}
      </Box>
      {currentBook ? (
        <Box my={1}>
          {editMode ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4} xl={3}>
                {/* <FormControlLabel
                                className={classes.formControlLabel}
                                control={ <Checkbox 
                                                checked={standard.available} 
                                                onChange={(e) => setStandard({...standard, available: e.target.checked})} 
                                                name="standard_delivery"
                                        />}
                                label="Standard Delivery"
                            /> */}
                {standard.available && (
                  // </FormControl>
                  <TextField
                    label="Standard Delivery Price"
                    type="number"
                    value={standard.price}
                    onChange={(e) =>
                      setStandard({ ...standard, price: e.target.value })
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    className={classes.priceFields}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={3}>
                {/* <FormControlLabel
                                className={classes.formControlLabel}
                                control={ <Checkbox 
                                                checked={threeDay.available} 
                                                onChange={(e) => setThreeDay({...threeDay, available: e.target.checked})} 
                                                name="three_day_delivery"
                                        />}
                                label="Three Day Delivery"
                            /> */}
                {threeDay.available && (
                  // </FormControl>
                  <TextField
                    label="Three Days Delivery Price"
                    type="number"
                    value={threeDay.price}
                    onChange={(e) =>
                      setThreeDay({ ...threeDay, price: e.target.value })
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    className={classes.priceFields}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={3}>
                {/* <FormControlLabel
                                className={classes.formControlLabel}
                                control={ <Checkbox 
                                                checked={nextDay.available} 
                                                onChange={(e) => setNextDay({...nextDay, available: e.target.checked})} 
                                                name="next_day_delivery"
                                        />}
                                label="Next Day Delivery"
                            /> */}
                {nextDay.available && (
                  // </FormControl>
                  <TextField
                    label="Next Day Delivery Price"
                    type="number"
                    value={nextDay.price}
                    onChange={(e) =>
                      setNextDay({ ...nextDay, price: e.target.value })
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    className={classes.priceFields}
                  />
                )}
              </Grid>
            </Grid>
          ) : (
            <Box>
              {currentBook && currentBook.delivery && (
                <Grid container spacing={2}>
                  {currentBook.delivery.standard_delivery && (
                    <Grid item xs={12} sm={6} md={4} xl={3}>
                      <h3 className={classes.subHeading}>Standard Delivery</h3>
                      <h3 className={classes.subValue}>
                        $ {currentBook.delivery.standard_delivery}
                      </h3>
                    </Grid>
                  )}
                  {currentBook.delivery.three_days_delivery !== undefined &&
                    currentBook.delivery.three_days_delivery !== 0 && (
                      <Grid item xs={12} sm={6} md={4} xl={3}>
                        <h3 className={classes.subHeading}>
                          Three Day Delivery
                        </h3>
                        <h3 className={classes.subValue}>
                          $ {currentBook.delivery.three_days_delivery}
                        </h3>
                      </Grid>
                    )}
                  {currentBook.delivery.next_day_delivery !== undefined &&
                    currentBook.delivery.next_day_delivery !== 0 && (
                      <Grid item xs={12} sm={6} md={4} xl={3}>
                        <h3 className={classes.subHeading}>
                          Next Day Delivery
                        </h3>
                        <h3 className={classes.subValue}>
                          $ {currentBook.delivery.next_day_delivery}
                        </h3>
                      </Grid>
                    )}
                </Grid>
              )}
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton animation="wave" width={250} height={50} />
              <Skeleton animation="wave" width={150} height={30} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton animation="wave" width={250} height={50} />
              <Skeleton animation="wave" width={150} height={30} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton animation="wave" width={250} height={50} />
              <Skeleton animation="wave" width={150} height={30} />
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  );
}

export default Delivery;
